<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_user_temporary_trace"
        :columns="columns"
        :url="url"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-column-visible="true"
        :show-add="false"
      />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import TableWrapper from '@/components/table-wrapper'
export default {
  name: 'VehicleTrace',
  components: {
    TableWrapper
  },
  data() {
    return {
      url: this.$config.apiContextPath + '/temporary/log',
      action: '',
      garages: this.loadGarages()
    }
  },
  computed: {
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '日期', width: '190px', options: {
            shortcuts: [
              {
                text: '一周',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                  return [start, end]
                }
              },
              {
                text: '一个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                  return [start, end]
                }
              },
              {
                text: '三个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                  return [start, end]
                }
              }
            ]
          }, placeholder: '请选择出入日期...', type: 'dateranger' },
          { label: '临停车库', placeholder: '请选择临停车库...', name: 'parkingId', width: 'auto', type: 'select', options: this.garages },
          { label: '临停用户', placeholder: '请输入临停用户...', name: 'user', width: '120px', type: 'input' },
          { label: '用户手机', placeholder: '请输入用户手机...', name: 'mobile', width: '120px', type: 'input' }
        ]
      }
    },
    columns() {
      return [
        { title: '序号', type: 'index', width: 80, align: 'center' },
        { title: '临停车库', align: 'left', key: 'parking', sortable: true, width: 200, type: 'select', options: this.garages, ellipsis: true, tooltip: true },
        { title: '临停用户', align: 'center', key: 'member', sortable: true, width: 200,
          render: (h, params) => {
            return h('span', {}, params.row.member || '---')
          }
        },
        { title: '用户手机', align: 'center', key: 'mobile', sortable: true, width: 200 },
        { title: '开门时间', align: 'center', key: 'openGateTime', sortable: true, width: 200, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.openGateTime || '---')
          }
        },
        { title: '结束时间', align: 'center', key: 'terminateTime', sortable: true, width: 200, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.terminateTime || '---')
          }
        },
        { title: '是否结束临停', align: 'center', key: 'isTerminated', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.isTerminated ? 'red' : '#000' }
            }, params.row.isTerminated ? '是' : '否')
          }
        }
      ]
    }
  },
  methods: {
    async loadGarages() {
      await request({
        url: this.$config.apiContextPath + '/parking/list',
        method: 'get'
      }).then(res => {
        this.garages = []
        const items = res.data
        items.forEach(i => {
          this.garages.push({ label: i.name, value: i.id })
        })
      }).catch(error => {
        console.log(error)
        this.garages = []
      })
    }
  }
}
</script>
